import { inject, Service } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectEntries, selectLoaded, selectLoading, selectTotal } from '../selectors/stock-history.selector';
import { stockHistoryActions } from '../actions/stock-history.actions';
import { GetStockHistoryValue, StockHistoryMode } from '../models';

@Service()
export class StockHistoryFacade {
    private readonly store = inject(Store);

    readonly entries = this.store.selectSignal(selectEntries);
    readonly loaded = this.store.selectSignal(selectLoaded);
    readonly loading = this.store.selectSignal(selectLoading);
    readonly total = this.store.selectSignal(selectTotal);

    getHistory(mode: StockHistoryMode, value: GetStockHistoryValue): void {
        this.store.dispatch(stockHistoryActions.getHistory({ mode, value }));
    }

    clear(): void {
        this.store.dispatch(stockHistoryActions.clear());
    }
}
